<template>
  <v-layout>
    <AppForm label="ユーザ種別">
      <template v-if="!isSystemOwner">
        <v-select
          v-model="inputValue"
          :disabled="disabled"
          :items="items"
          class="pa-0 ma-0"
          style="max-width:320px;"
        />
        <p v-if="caution" class="caution-message">{{ caution }}</p>
      </template>
      <template v-else>{{ current.text }}</template>
    </AppForm>
  </v-layout>
</template>

<script>
const userTypeObjs = [
  { text: '営業', value: 'sales' },
  { text: '営業マネージャー', value: 'sales manager' },
  { text: '運用', value: 'operator' },
  { text: '運用マネージャー', value: 'operator manager' },
  { text: '管理者', value: 'administrator' },
]

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    caution: {
      type: String,
      default: '',
    },
    permission: {
      type: String,
      default: 'admin',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isSystemOwner: Boolean,
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    selectableUserTypes() {
      if (this.permission === 'readonly') return ['sales']
      if (this.permission === 'operator') {
        return ['sales', 'sales manager', 'operator']
      }
      return [
        'sales',
        'sales manager',
        'operator',
        'operator manager',
        'administrator',
      ]
    },
    items() {
      return this.selectableUserTypes.map(userType =>
        userTypeObjs.find(obj => obj.value === userType),
      )
    },
    current() {
      return userTypeObjs.find(obj => obj.value === this.inputValue) || {}
    },
  },
}
</script>

<style scoped>
.caution-message {
  color: red;
  white-space: pre-line;
}
</style>
